import React, { Component } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import TextField from '@material-ui/core/TextField';
import { FileUpload } from 'primereact/fileupload';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { connect } from 'react-redux';
import Moment from 'react-moment';
import { ToastContainer, toast } from 'react-toastify';
import { roleMasterActions, userMasterActions } from '../../actions';
import tableRequest from '../../models/tableRequest';
// import { userTypeMasterActions } from '../../actions';
import Switch from '@material-ui/core/Switch';

class userMaster extends Component {
    constructor(props) {
        super(props);
        this.tblResponse = new tableRequest();
        this.statusBodyTemplate = this.statusBodyTemplate.bind(this);
        this.actionBodyTemplate = this.actionBodyTemplate.bind(this);
        this.switchToggleConfirm = this.switchToggleConfirm.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.openDialog = this.openDialog.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.CreatedDateTemplate = this.CreatedDateTemplate.bind(this);
        this.UpdatedDateTemplate = this.UpdatedDateTemplate.bind(this)
        this.resetForm = this.resetForm.bind(this);
        this.onHide = this.onHide.bind(this);
        this.getRoleDDL = this.getRoleDDL.bind(this);
        this.state = {
            loading: false,
            buttonLabel: 'Submit',
            switchAction: false,
            formHeading: 'Add User Master',
            UserId: 0,
            RoleId: 0,
            UserTypeId: '',
            UserName: '',
            Email: '',
            MobileNo: '',
            Password: '',
            ConfirmPassword: '',
            IsActive: true,
            CreatedDate: null,
            UpdatedDate: null,
            formError: {
                UserName: '',
                UserTypeId: '',
                Email: '',
                MobileNo: '',
                Password: '',
                ConfirmPassword: '',
                RoleId: ''
            }
        };
    }
    componentDidMount() {
        this.props.fetchApi(this.tblResponse);
        this.props.getRoleDDL();
    }

    switchToggleConfirm = (e) => {
        this.setState({ confirm: true, displayConfirmation: false })
        const formData = {
            UserId: this.state.UserId
        }
        this.props.inActiveRow(this.state.UserId);
    }
    handleChange(event) {
        let { name, value } = event.target;
        let errors = this.state.formError;
        switch (name) {
            case 'IsActive':
                value = event.target.checked;
                break;
            default:
                break;
        }
        this.validateForm(value, name);
        this.setState({ errors, [name]: value });
    }
    UpdatedDateTemplate(rowData) {
        if (rowData.UpdatedDate !== null) {
            return (
                <Moment format="D MMM YYYY">{rowData.UpdatedDate}</Moment>
            )
        }
        else {

        }
    }

    CreatedDateTemplate(rowData) {
        if (rowData.UpdatedDate !== null) {

            return (
                <Moment format="D MMM YYYY">{rowData.CreatedDate}</Moment>
            )
        }
    }
    validateForm(value, name) {
        let errors = this.state.formError;
        let IsValid = true;
        switch (name) {
            case 'UserName':
                if (value.length < 1) {
                    IsValid = false;
                    errors.UserName = "Please enter user name.";
                } else errors.UserName = ''
                break;
            // case 'UserTypeId':
            //     if (value.length < 1) {
            //         IsValid = false;
            //         errors.UserTypeId = "Please select user type.";
            //     } else errors.UserTypeId = ''
            //     break;
            case 'RoleId':
                if (!value) {
                    IsValid = false;
                    errors.RoleId = "Please select user role.";
                } else errors.RoleId = ''
                break;
            // case 'FirstName':
            //     if (value.length < 1) {
            //         IsValid = false;
            //         errors.FirstName = "Please enter your first name.";
            //     }
            //     else if (value.length >= 1) {
            //         if (!value.match(/^[A-Za-z]+$/)) {
            //             IsValid = false;
            //             errors.FirstName = "FirstName should be alpha only."
            //         } else errors.FirstName = ''
            //     }
            //     else errors.FirstName = ''
            //     break;
            // case 'LastName':
            //     if (value.length < 1) {
            //         IsValid = false;
            //         errors.LastName = "Please enter your last name.";
            //     }
            //     else if (value.length >= 1) {
            //         if (!value.match(/^[A-Za-z]+$/)) {
            //             IsValid = false;
            //             errors.LastName = "LastName should be alpha only."
            //         } else errors.LastName = ''
            //     }
            //     else errors.LastName = ''
            //     break;
            case 'Email':
                if (value.length < 1) {
                    IsValid = false;
                    errors.Email = "Please enter email-id.";
                }
                else if (value.length >= 1) {
                    /* eslint-disable */
                    if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
                        IsValid = false;
                        errors.Email = "Please enter valid email-id.";
                    } else errors.Email = ''
                    /* eslint-enable */
                } else errors.Email = ''
                break;
            case 'MobileNo':
                if (value.length < 1) {
                    IsValid = false;
                    errors.MobileNo = "Please enter mobile no.";
                }
                else if (value.length >= 1) {
                    if (!value.match(/^[6-9]\d{9}$/)) {
                        IsValid = true;
                        errors.MobileNo = "Please enter valid mobile no.";
                    } else errors.MobileNo = ''
                } else errors.MobileNo = ''
                break;
            case 'Password':
                if (value.length < 1) {
                    IsValid = false;
                    errors.Password = "Please enter password.";
                }
                else if (!value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{4,20}$/)) {
                    IsValid = false;
                    errors.Password = "Password should be minimum 4 characters long, 1 uppercase & 1 lowercase character with 1 number.";
                }
                else if (value.length >= 1 && this.state.ConfirmPassword.length >= 1) {
                    errors.Password = '';
                    errors.ConfirmPassword = '';
                    if (!(value === this.state.ConfirmPassword)) {
                        IsValid = false;
                        errors.Password = "password does not match";
                    } else errors.Password = ''
                } else errors.Password = ''
                break;

            case 'ConfirmPassword':
                if (value.length < 1) {
                    IsValid = false;
                    errors.ConfirmPassword = "Please enter confirm password.";
                }
                else if (!value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{4,20}$/)) {
                    IsValid = false;
                    errors.ConfirmPassword = "Password should be minimum 4 characters long, 1 uppercase & 1 lowercase character with 1 number.";
                }
                else if (value.length >= 1 && this.state.Password.length >= 1) {
                    errors.Password = '';
                    errors.ConfirmPassword = '';
                    if (!(value === this.state.Password)) {
                        IsValid = false;
                        errors.ConfirmPassword = "Confirm password does not match";
                    } else errors.ConfirmPassword = ''
                } else errors.ConfirmPassword = ''
                break;
            default:
                break;
        }

        return IsValid;
    }

    getDropValueOfRole() {
        let roleName = '';
        this.props.UserRoleData.filter(x => {
            if (x.value === this.state.RoleId.toString()) {
                roleName = x.label;
            }
        });

        return roleName;
    }

    submitForm(event) {
        ;
        event.preventDefault();
        let isfrmvalid = true;
        let checkerror = this.state.formError;

        Object.entries(checkerror).map(([key, value]) => {
            const val = this.state[key]
            let valid = this.validateForm(val, key);
            if (!valid) {
                this.setState({ checkerror: isfrmvalid });
                isfrmvalid = false;
            }
            return isfrmvalid;
        });

        if (isfrmvalid) {
            ;
            const ddlValuRole = this.getDropValueOfRole();
            const formData = {
                UserId: this.state.UserId,
                RoleId: this.state.RoleId,
                UserName: this.state.UserName,
                Email: this.state.Email,
                MobileNo: this.state.MobileNo,
                Password: this.state.Password,
                IsActive: this.state.IsActive,
                CreatedDate: this.state.UserId > 0 ? this.state.CreatedDate : this.getCurrentDateMMDDYYY(),
                UpdatedDate: this.state.UserId > 0 ? this.getCurrentDateMMDDYYY() : null,
                RoleName: ddlValuRole != null ? ddlValuRole : ""
            }
            if (formData.UserId > 0) {
                this.props.updateUser(formData);
            }
            else {
                this.props.createUser(formData);
            }

            if (!this.props.showDialog) {
                this.resetForm();
            }
        }
    }

    getRoleDDL(event) {
        this.props.getRoleDDL();
    }
    resetForm() {
        this.setState({
            UserId: '',
            UserTypeId: '',
            UserName: '',
            Email: '',
            MobileNo: '',
            Password: '',
            ConfirmPassword: '',
            IsActive: true,
            formError: {
                UserName: '',
                UserTypeId: '',
                Email: '',
                MobileNo: '',
                Password: '',
                ConfirmPassword: '',
            }
        });

        let errors = this.state.formError;
        Object.entries(errors).map(([key]) => {
            errors[key] = '';
            return errors[key];
        });
    }

    onHide() {
        this.props.onHideShow(false);
        this.resetForm();
    }
    openDialog() {
        this.props.onHideShow(true);
        this.setState({ buttonLabel: 'Submit', formHeading: 'Add User' })
    }
    statusBodyTemplate(rowData) {

        if (rowData) {
            return (
                <Checkbox
                    disabled
                    checked={rowData.IsActive}
                    color="primary"
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                />
            )
        }
    }
    getCurrentDateMMDDYYY() {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();

        today = mm + '/' + dd + '/' + yyyy;
        return today;
    }
    actionBodyTemplate(rowData) {
        const editMode = (e) => {
            this.props.onHideShow(true);
            this.setState({
                buttonLabel: 'Update',
                formHeading: 'Update User Master',
                UserId: rowData.UserId,
                UserName: rowData.UserName,
                Email: rowData.Email,
                MobileNo: rowData.MobileNo,
                RoleId: rowData.RoleId,
                IsActive: rowData.IsActive,
                Password: rowData.Password,
                ConfirmPassword: rowData.Password,
                CreatedDate: rowData.CreatedDate
            });
        }
        const switchHandleChange = (e) => {
            this.setState({
                switchAction: !this.state.switchAction,
                UserId: rowData.UserId
            });
            if (!this.state.switchAction) {
                this.setState({
                    displayConfirmation: true
                })
            }
        }
        if (rowData) {
            if (rowData.IsActive == true) {
                return (
                    <>
                        <Switch checked={true} color="primary" name={rowData.UserId}
                            onChange={switchHandleChange} inputProps={{ 'aria-label': 'secondary checkbox' }}
                        />
                        <Button icon="pi pi-pencil" onClick={editMode} />
                    </>
                )
            }
            else {
                return (
                    <>
                        <Switch checked={false} color="primary" disabled
                            name={rowData.UserId} onChange={switchHandleChange} inputProps={{ 'aria-label': 'secondary checkbox' }}
                        />
                        <Button icon="pi pi-pencil" onClick={editMode} />
                    </>
                )
            }
        }
    }

    render() {
        const renderFooter = (name) => {
            return (
                <div>
                    <Button label="No" icon="pi pi-times" onClick={() => this.setState({ displayConfirmation: false })} className="p-button-text" />
                    <Button label="Yes" icon="pi pi-check" onClick={this.switchToggleConfirm} autoFocus />
                </div>
            );
        }
        const header = (
            <div className="table-header row">
                <div className="col-md-6">
                    <h4>User Master</h4>
                </div>
                <div className="col-md-6 text-right">
                    <span className="p-input-icon-left mr-2">
                        <i className="pi pi-search" />
                        <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Global Search" />
                    </span>
                    <Button className="mr-2" icon="pi pi-plus" label="Add" onClick={this.openDialog} />
                    {/* <Button type="button" icon="pi pi-external-link" label="Export" onClick={this.exportCSV}></Button> */}
                </div>
            </div>
        );

        return (
            <div className="datatable-filter-demo">
                <ToastContainer />

                <div className="card">
                    <DataTable value={this.props.UserData} ref={(el) => { this.dt = el; }} header={header} globalFilter={this.state.globalFilter} className="p-datatable-customers" rowHover={true} loading={this.state.loading} emptyMessage="No data found." sortMode="multiple" paginator
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={5} rowsPerPageOptions={[5, 10, 20, 50]} >
                        
                        <Column field="UserName" header="User Name" sortable></Column>
                        <Column field="RoleName" header="Role Name" sortable></Column>
                        <Column field="Email" header="Email" sortable></Column>
                        <Column field="MobileNo" header="Mobile Number" sortable></Column>
                        {/* <Column field="CreatedDate" body={this.CreatedDateTemplate} header="Created Date" sortable></Column>
                        <Column field="UpdatedDate" body={this.UpdatedDateTemplate} header="Updated Date" sortable></Column> */}
                        {/* <Column field="Status" style={{ width: '70px' }} header="Status" body={this.statusBodyTemplate}></Column> */}
                        <Column field="Action" header="Action" style={{ width: '120px' }} body={this.actionBodyTemplate}></Column>
                        {/* {dynamicColumns} */}
                    </DataTable>
                </div>
                <Dialog header={this.state.formHeading} modal dismissableMask={true} visible={this.props.showDialog} style={{ width: '50vw' }} onHide={this.onHide}>
                    <form onSubmit={this.submitForm} autocomplete="off">
                        <div className="row">
                            <div className="col-md-6 pt-2">
                                <TextField onChange={this.handleChange} name="UserName" autoComplete="false" value={this.state.UserName} size="small" variant="outlined" className="fullwidth" label="User Name*" />
                                {this.state.formError.UserName !== '' ?
                                    <div className='error'>{this.state.formError.UserName}</div> : ''}
                            </div>
                            <div className="col-md-6 pt-3">
                                <FormControl variant="outlined" size="small" className="formControl col-md-12">
                                    <InputLabel id="demo-simple-select-outlined-label">Select User Role*</InputLabel>
                                    <Select onChange={this.handleChange} name="RoleId" value={this.state.RoleId} labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" label="Select User Role">
                                        <MenuItem>
                                            <em>None</em>
                                        </MenuItem>

                                        {this.props.UserRoleData == (undefined || null) ? null : this.props.UserRoleData.map(key => (
                                            <MenuItem value={key.value}>{key.label}</MenuItem>
                                            )
                                        )}
                                    </Select>
                                </FormControl>
                                {this.state.formError.RoleId !== '' ?
                                    <div className='error'>{this.state.formError.RoleId}</div> : ''}
                            </div>
                            <div className="col-md-6 pt-3">
                                <TextField onChange={this.handleChange} name="Email" value={this.state.Email} size="small" variant="outlined" className="fullwidth" label="Email*" />
                                {this.state.formError.Email !== '' ?
                                    <div className='error'>{this.state.formError.Email}</div> : ''}
                            </div>
                            {/* <div className="col-md-6 pt-3">
                                <TextField onChange={this.handleChange} name="MobileNo" value={this.state.MobileNo} size="small" variant="outlined" className="fullwidth" label="Mobile Number*" />
                                {this.state.formError.MobileNo !== '' ?
                                    <div className='error'>{this.state.formError.MobileNo}</div> : ''}
                            </div> */}
                            <div className="col-md-6 pt-3">
                                <TextField id="standard-basic" size="small" onChange={this.handleChange} variant="outlined"
                                    name="MobileNo" value={this.state.MobileNo} className="fullwidth" label="Mobile Number*" />
                                {this.state.formError.MobileNo !==
                                    '' ?
                                    <div className='error'>{this.state.formError.MobileNo}</div> : ''}
                            </div>
                            <div className="col-md-6 pt-3">
                                <TextField input type="password" autocomplete="new-password" onChange={this.handleChange} name="Password" value={this.state.Password} size="small" variant="outlined" className="fullwidth" label="Password*" />
                                {this.state.formError.Password !== '' ?
                                    <div className='error'>{this.state.formError.Password}</div> : ''}
                            </div>
                            <div className="col-md-6 pt-3">
                                <TextField input type="password" onChange={this.handleChange} name="ConfirmPassword" value={this.state.ConfirmPassword} size="small" variant="outlined" className="fullwidth" label="Confirm Password*" />
                                {this.state.formError.ConfirmPassword !== '' ?
                                    <div className='error'>{this.state.formError.ConfirmPassword}</div> : ''}
                            </div>
                            <div className="col-md-6 pt-3">
                                <Checkbox
                                    name="IsActive"
                                    checked={this.state.IsActive}
                                    onClick={this.handleChange}
                                    color="primary"
                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                /> <label>Is Active</label>
                            </div>

                            <div className="col-md-12 mt-3 mb-3 text-center">
                                <Button label={this.state.buttonLabel} icon="pi pi-check" />
                            </div>
                            <div class="col-md-12">
                                Note: Fields marked as (*) are required
                            </div>
                        </div>
                    </form>
                </Dialog>
                <Dialog header="Confirmation" visible={this.state.displayConfirmation} modal style={{ width: '350px' }} footer={renderFooter('displayConfirmation')} onHide={() => this.setState({ displayConfirmation: false })}>
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle p-mr-3 confirm-icon" style={{ fontSize: '2rem' }} />
                        <span>Are you sure you want to InActive?</span>
                    </div>
                </Dialog>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        UserData: state.user.items,
        UserRoleData: state.role.rollddl,
        showDialog: state.role.showDialog
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchApi: (obj) => {
            dispatch(userMasterActions.getAll(obj))
        },
        fetchUserRole: () => {
            dispatch(roleMasterActions.getAll())
        },
        createUser: user => dispatch(userMasterActions.createUser(user)),
        updateUser: user => dispatch(userMasterActions.updateUser(user)),
        inActiveRow: user => dispatch(userMasterActions.inActiveRow(user)),
        onHideShow: isbool => dispatch(userMasterActions.onHideShow(isbool)),
        getRoleDDL: () => dispatch(roleMasterActions.getRoleDDL())
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(userMaster)